
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleethColour as ObiSleethColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleeth-colour.js';
 
 
 

 
 export const ObiSleethColour = createComponent({
   react: React,
   tagName: 'obi-sleeth-colour',
   elementClass: ObiSleethColourElement,
   events: {
     
   }
  });
 
 